// extracted by mini-css-extract-plugin
export var grid = "_17-0";
export var span1 = "_17-2";
export var span10 = "_17-b";
export var span10L = "_17-z";
export var span10M = "_17-n";
export var span10Xl = "_17-1b";
export var span11 = "_17-c";
export var span11L = "_17-10";
export var span11M = "_17-o";
export var span11Xl = "_17-1c";
export var span12 = "_17-d";
export var span12L = "_17-11";
export var span12M = "_17-p";
export var span12Xl = "_17-1d";
export var span1L = "_17-q";
export var span1M = "_17-e";
export var span1Xl = "_17-12";
export var span2 = "_17-3";
export var span2L = "_17-r";
export var span2M = "_17-f";
export var span2Xl = "_17-13";
export var span3 = "_17-4";
export var span3L = "_17-s";
export var span3M = "_17-g";
export var span3Xl = "_17-14";
export var span4 = "_17-5";
export var span4L = "_17-t";
export var span4M = "_17-h";
export var span4Xl = "_17-15";
export var span5 = "_17-6";
export var span5L = "_17-u";
export var span5M = "_17-i";
export var span5Xl = "_17-16";
export var span6 = "_17-7";
export var span6L = "_17-v";
export var span6M = "_17-j";
export var span6Xl = "_17-17";
export var span7 = "_17-8";
export var span7L = "_17-w";
export var span7M = "_17-k";
export var span7Xl = "_17-18";
export var span8 = "_17-9";
export var span8L = "_17-x";
export var span8M = "_17-l";
export var span8Xl = "_17-19";
export var span9 = "_17-a";
export var span9L = "_17-y";
export var span9M = "_17-m";
export var span9Xl = "_17-1a";
export var stretch = "_17-1";